<div class="col-12 p-0 collapse" id="collapseCSV" *ngIf="!hidePopup">
  <ng-container *ngIf="statusData && statusData.length">
    <ng-container *ngFor="let item of statusData">
      <div class="d-flex col-12 border-bottom justify-content-between align-items-center mb-2 py-2"
        *ngIf="item.import_taxonomy_setting && item.status !== 8">
        <div class="col-7 p-0">
          <p class="mb-0 text-truncate">{{item['import_taxonomy_setting'].taxonomy_title}}</p>
        </div>

        <ng-container [ngSwitch]="item.status">
          <div class="col-auto p-0">
            <p class="mb-0 text-secondary font-bold pr-1" *ngSwitchCase="1">In Queue</p>
            <p class="mb-0 text-primary font-bold pr-1" *ngSwitchCase="2">Inprogress</p>
            <p class="mb-0 text-danger font-bold pr-1" *ngSwitchCase="4">Failed</p>
            <p class="mb-0 text-info font-bold pr-1" *ngSwitchCase="5">Initializing</p>
            <p class="mb-0">
              <button class="btn btn-clear btn-sm text-success p-1 font-bold" *ngSwitchCase="3"
                (click)="onViewSummary($event,item.batch_id,0)">Successful</button>
              <button class="btn btn-clear btn-sm text-success p-1 font-bold" *ngSwitchCase="6"
                (click)="onViewSummary($event,item.batch_id,1)">Ready for review</button>
            </p>
            <p class="mb-0 text-danger font-bold pr-1" *ngSwitchCase="7">Expired</p>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</div>
